import { CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
  color?: string;
}

export const BrandAwareness = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      style={props.style ? props.style : undefined}
    >
      <path
        d="M640-440v-80h160v80H640Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM120-360v-240h160l200-200v640L280-360H120Zm280-246-86 86H200v80h114l86 86v-252ZM300-480Z"
        fill={props.color ? props.color : undefined}
      />
    </svg>
  );
};
